import React, { useState } from "react";
import styles from "./style/comp3.module.css";

export default function TrainCard({
    trainNumber="12345",
    trainName = "12345, Rajdhani Express",
    trainType = "Train",
    from = { station: "Secunderabad Jn", code: "SC", time: "18:00", date: "11 May" },
    to = { station: "Agra Cantt", code: "AGC", time: "18:00", date: "12 May" },
    duration = "22hr 15min",
    halts = "23 halts",
    classInfo = { type: "Class", seats: 33 },
    quota = "₹3,350",
    bookUrl = "",
    note= [
        "Book a ticket from KSR Bengaluru City Junction to Agra Cantt, as there are no seats available from Secunderabad.",
        "Tatkal booking opens at 10 AM for AC classes and 11 AM for non-AC classes, one day before the journey."
      ],
    info = [
        // {
        //     class: "1A",
        //     Quota: "GN",
        //     price: 1200.00,
        //     seats: "AVA 0222",
        //     available: 1
        // },
        // {
        //     class: "2A",
        //     Quota: "GN",
        //     price: 850.00,
        //     seats: "WL 03",
        //     available: 0
        // },
        // {
        //     class: "3A",
        //     Quota: "GN",
        //     price: 650.00,
        //     seats: "CNF 45",
        //     available: 1
        // },
        // {
        //     class: "SL",
        //     Quota: "GN",
        //     price: 285.00,
        //     seats: "AVA 89",
        //     available: 1
        // },
        // {
        //     class: "CC",
        //     Quota: "GN",
        //     price: 420.00,
        //     seats: "WL 15",
        //     available: 0
        // },
        // {
        //     class: "2S",
        //     Quota: "GN",
        //     price: 125.00,
        //     seats: "AVA 234",
        //     available: 1
        // },
    ]
}) {
    const [refreshingIdx, setRefreshingIdx] = useState(null);
    const [refreshedInfo, setRefreshedInfo] = useState({});

    const getStatusColor = (seats, available) => {
        // Convert available to number if it's a string
        const availableNum = Number(available);

        if(seats=='N/A') return '#64748b';
        
        // Debug logging
        //console.log('Available value:', available, 'Converted:', availableNum);
        
        // First check the available flag as it's the most direct indicator
        if (availableNum === 1) return '#16A34A';  // Green for available
        if (availableNum === 0) return '#DC2626';  // Red for not available

        // If available flag is not set, fall back to seats string parsing
        if (!seats || typeof seats !== 'string') return "#64748b"; // Gray for invalid input

        //const s = seats.toUpperCase();
        
        // if (s.includes('N/A')) return '#64748b';  // Gray for N/A
        // if (s.includes('AVA') || s.includes('CNF') || s.includes('AVL')) return '#16A34A';  // Green for available
        // if (s.includes('WL')) return '#f59e0b';  // Orange for waitlist
        // if (s.includes('RAC')) return '#3b82f6';  // Blue for RAC
        
        return "#64748b";  // Gray as default
    };

    const handleRefresh = async (item, idx) => {
        setRefreshingIdx(idx);
        try {
            const params = new URLSearchParams(item.refreshBody).toString();
            const url = `https://hh183pxn0f.execute-api.ap-south-1.amazonaws.com/development/search?${params}`;
            const res = await fetch(url, { method: "GET" });
            const data = await res.json();
            
            if (data.status === 200 && data.data?.seat_avail_ui) {
                console.log('Refresh data:', data.data.seat_avail_ui);
                setRefreshedInfo(prev => ({
                    ...prev,
                    [idx]: {
                        avl: data.data.seat_avail_ui.avl,
                        fare: data.data.seat_avail_ui.fare,
                        updated_at: data.data.seat_avail_ui.updated_at_ui,
                        comment: data.data.seat_avail_ui.comment,
                        Quota: data.data.seat_avail_ui.quota,
                        seat_class: data.data.seat_avail_ui.seat_class || 'N/A',
                        available: data.data.seat_avail_ui.is_avail ? 1 : 0,  // Ensure it's set as 1 or 0
                    }
                }));

                if (info && info[idx]) {
                    info[idx] = {
                        ...info[idx],
                        // avl: data.data.seat_avail_ui.avl,
                        // fare: data.data.seat_avail_ui.fare,
                        // updated_at: data.data.seat_avail_ui.updated_at_ui,
                        // comment: data.data.seat_avail_ui.comment,
                        // Quota: data.data.seat_avail_ui.quota,
                        // seats: data.data.seat_avail_ui.seat_class || 'N/A',
                        available: data.data.seat_avail_ui.is_avail ? 1 : 0, 
                    };
                }
            } else {
                setRefreshedInfo(prev => ({
                    ...prev,
                    [idx]: { error: data.message || "Failed to refresh" }
                }));
            }
        } catch (e) {
            console.error('Refresh error:', e);
            setRefreshedInfo(prev => ({
                ...prev,
                [idx]: { error: "Failed to refresh" }
            }));
        } finally {
            setTimeout(() => {
                setRefreshingIdx(null);
            }, 500);
        }
    };

    return (
        <div className={styles.card}>
            <div className={styles.headerRow}>
                <div className={styles.trainName}>{trainNumber}, {trainName}</div>
                <div className={styles.trainType}>{trainType}</div>
            </div>
            <div className={styles.infoColumn}>
                <div className={styles.infoRow}>
                    <div className={styles.stationBlock}>
                        <div className={styles.stationName}>{from.station}</div>
                        <div className={styles.stationCodeTime}>
                            <span className={styles.stationCode}>{from.code}</span>
                            <span className={styles.stationTime}>, {from.time}</span>
                        </div>
                        <div className={styles.stationDate}>{from.date}</div>
                    </div>
                    <div className={styles.middleBlock}>
                        <div className={styles.duration}>{duration}</div>
                        {/* <div className={styles.halts}>{halts}</div> */}
                    </div>
                    <div className={styles.stationBlock} style={{ textAlign: "right" }}>
                        <div className={styles.stationName}>{to.station}</div>
                        <div className={styles.stationCodeTime}>
                            <span className={styles.stationCode}>{to.code}</span>
                            <span className={styles.stationTime}>, {to.time}</span>
                        </div>
                        <div className={styles.stationDate}>{to.date}</div>
                    </div>
                </div>

                {info && info.length > 0 && (
                    <div className={styles.infoBlockGrid}>
                        {info.map((item, idx) => (
                            <div className={styles.infoBlockGridItem} key={idx}>
                                <div className={styles.infoCardGrid}>
                                    <div className={styles.infoTopLeft}>{item.class}</div>
                                    <div className={styles.infoTopRight}>({refreshedInfo[idx]?.Quota || item.Quota})</div>
                                    <div className={styles.infoBottomLeft}>
                                        <span style={{ color: getStatusColor(refreshedInfo[idx]?.seat_class || item.seats, item.available) }}>
                                            {refreshedInfo[idx]?.avl || item.seats || "--"}
                                        </span>
                                    </div>
                                    <div className={styles.infoBottomRight}>
                                        ₹{refreshedInfo[idx]?.fare?.toLocaleString() || item.price?.toLocaleString() || "--"}
                                    </div>
                                </div>
                                <span
                                    className={`${styles.refreshIcon} ${refreshingIdx === idx ? styles.refreshing : ''}`}
                                    onClick={() => handleRefresh(item, idx)}
                                    title="Refresh seat availability"
                                >
                                    {refreshingIdx === idx ? (
                                        <svg width="22" height="22" viewBox="0 0 50 50" className={styles.loadingSpinner}>
                                            <circle cx="25" cy="25" r="20" stroke="#888" strokeWidth="4" fill="none" strokeDasharray="31.4 31.4" strokeLinecap="round">
                                                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
                                            </circle>
                                        </svg>
                                    ) : (
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                                            <path d="M4 4v5h5" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M2.5 10a7.5 7.5 0 1 1 2.2 5.3" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </span>
                            </div>
                        ))}
                    </div>
                )}

                {bookUrl && (
                    <div className={styles.bottomRow}>
                        <a href={bookUrl} className={styles.bookBtn} target="_blank" rel="noopener noreferrer">Book with IRCTC</a>
                    </div>
                )}
            </div>
            <ul className={styles.noteList}>
                {note.map((line, idx) => (
                    <li key={idx} className={styles.noteListItem}>
                        {line}
                    </li>
                ))}
            </ul>
        </div>
    );
}